/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/html-has-lang */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { HeadersFunction, LinksFunction, LoaderFunctionArgs } from "react-router";
import {
  isRouteErrorResponse,
  Links,
  Meta,
  Outlet,
  redirect,
  Scripts,
  ScrollRestoration,
  useLoaderData,
  useMatches,
  useNavigation,
  useParams,
  useRouteError,
} from "react-router";

import { useTranslation } from "react-i18next";
import { useChangeLanguage } from "remix-i18next/react";
import i18next from "~/localization/i18n.server";
import WebHeader from "./components/shared-components/WebHeader";

import { useLocation } from "react-router";

import { useEffect } from "react";
import SearchBar from "./components/shared-components/SearchBar";
import TitlePreview from "./components/shared-components/TitlePreview";
import { cn } from "./lib/utils";
import { returnLanguageIfSupported } from "./localization/resource";
import "./tailwind.css";

import { parse } from "cookie";
import { AnimatePresence, motion } from "framer-motion";
import { Provider } from "react-redux";
import InternalServerError from "./components/InternalServerError";
import NotFoundPage from "./components/NotFoundPage";
import Footer from "./components/shared-components/Footer";
import GlobalAudioPlayer from "./components/shared-components/GlobalAudioPlayer";
import HeaderImage from "./components/shared-components/HeaderImage";
import ScrollToTopButton from "./components/shared-components/ScrollToTopButton";
import SearchBarAndMenuMobile from "./components/shared-components/SearchBarAndMenuMobile";
import DesktopMenu from "./components/shared-components/desktop-menu";
import MobileMenu from "./components/shared-components/mobile-menu";
import SuperHeader from "./components/super-header/SuperHeader";
import { Sheet, SheetClose, SheetContent, SheetHeader } from "./components/ui/sheet";
import { Toaster } from "./components/ui/sonner";
import { DISPLAY_TYPE } from "./components/video-grid/video-data";
import GlobalVideoPlayer from "./components/youtube/GlobalVideoPlayer";
import useActivityTracking from "./hook/useActivityTracking";
import useDisplayStickyButton from "./hook/useDisplayStickyButton";
import useLocale from "./hook/useLocale";
// import { trackPageView } from "./lib/firebase/analytics";
import { onMessage } from "firebase/messaging";
import NodataFound from "./components/shared-components/NoDataFound";
import { trackPageView } from "./lib/firebase/analytics";
import { stickyWebHeaderVariants } from "./lib/motion-obj";
import { myStore } from "./lib/store/store";
import StoreProvider from "./lib/store/storeProvider";
import { i18nextMiddleware } from "./middleware/i18next";
import api from "./utils/Interceptor";
import API_PATH from "./utils/api-routes";
import {
  allowedCategories,
  AUTH_COOKIE_TOKEN,
  COOKIES_LANGUAGE,
  GUJARATI_ROUTE,
  LANG,
  PAGE_INDEX,
  VIDEO_CATEGORY_LIST_PAGE_SIZE as PAGE_SIZE,
} from "./utils/constant";
import IndexedDBService from "./utils/dbConfig";
import { messaging } from "./utils/firebase.client";
import getEnv from "./utils/get-env";
import { ApiService } from "./utils/service";
export const middleware = [i18nextMiddleware];

declare global {
  interface Window {
    closeSheet?: () => void;
  }
}

const skipEverything = [
  "$lang.chalt-maharaj",
  "$lang.nilkanthvarni",
  "$lang.charanavind",
  "$lang.ubha-maharaj",
  "$lang.chopai-view",
  "$lang.shorts",
  "$lang.satsang-quiz-m._index",
  "$lang.satsang-quiz-m.$quizId",
];

const skipTitlePreview = [
  "$lang._index",
  "$lang.sad-granth.$slug.($part)",
  "$lang.$slug.$id",
  "$lang.chopai-view",
  "$lang.thal.$recipeId",
  "$lang.non-member",
  "$lang.not-found",
  "$lang.book._index",
  "$lang.kirtan-lyrics",
  // "$lang.dhyan-murti._index",
  ...skipEverything,
];

const skipFooter = [
  "$lang.chopai-view",
  "$lang.not-found",
  "$lang.book._index",
  "$lang.kirtan-lyrics",
  "$lang.dhyan-murti._index",
  "$lang.thalbhet._index",
  "$lang.registration._index",
  ...skipEverything,
];
const DON_SHOW_FOOTER_IN_MOBILE = ["$lang.kirtan-lyrics", "$lang.shorts"];
const skipNavHeader = ["$lang.chopai-view", "$lang.not-found", "$lang.book._index", ...skipEverything];

const displayPlaylistFilter = ["$lang.$video_category.$slug.$(playlist_slug).$(last_slug)"];

const hiddenNavbar = [
  "$lang.$video_category.$slug.$(playlist_slug)",
  "$lang.$video_category.$slug.$(playlist_slug).$(last_slug)",
  "$lang.chopai-view",
  "$lang.book._index",
  "$lang.track-view",
];

const fullwidthRoutes = ["$lang._index", "$lang.not-found", "$lang.book._index"];
const skipFeedBackButton = [
  "$lang.chalt-maharaj",
  "$lang.nilkanthvarni",
  "$lang.charanavind",
  "$lang.ubha-maharaj",
  "$lang.kirtan-lyrics",
  "$lang.dhyan-murti._index",
  "$lang.chopai-view",
  "$lang.shorts",
  "$lang.thalbhet._index.$(token)",
  "$lang.registration.($token)",
  "$lang.satsang-quiz-m._index",
  "$lang.satsang-quiz-m.$quizId",
];

const hideHeaderRoutes = ["$lang.not-found"];

export const links: LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: "anonymous",
  },
  {
    rel: "preload",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap",
    as: "style",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Roboto+Mono:ital,wght@0,100..700;1,100..700&display=swap",
  },
  {
    rel: "stylesheet",
    href: "https://cdn.jsdelivr.net/npm/openseadragon@4.1.1/build/openseadragon/openseadragon.min.css",
  },
  { rel: "icon", href: "/favicon.ico" },
];

export async function loader({ request, params }: LoaderFunctionArgs) {
  const cookieHeader = request.headers.get("Cookie") || "";
  const _URL = new URL(request.url);
  const pathname = _URL.pathname;
  const watchId = _URL.searchParams.get("watch") || null;
  const media = _URL.searchParams.get("media") || "video";
  const lang = returnLanguageIfSupported(params.lang);
  const cookies = parse(cookieHeader);
  // request.headers.get("accept-language")?.split(",")[1].split(";")[0] ||
  // request.headers.get("accept-language")?.split(",")[1].split(";")[0] ||

  const { video_category: base_slug, slug: category_slug, playlist_slug, last_slug } = params;

  const payload = {
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
    base_slug: base_slug || "",
    category_slug: category_slug || "",
    slug: playlist_slug || null,
    trackId: watchId ? Number(watchId) : null,
    media: media as "audio" | "video",
    last_slug: last_slug || null,
  };

  const apiService = new ApiService(lang || LANG.english);

  const isValid = /^[a-z-]+$/.test(base_slug ?? "") && allowedCategories.includes(base_slug!);

  let response: any = null;
  if (isValid) {
    try {
      response = await apiService.getPlaylistVideoBaseOnCategory(payload);
    } catch (err) {
      response = null;
    }
  }

  const playlistDetails = response?.playlist || {};
  const isBranch =
    playlistDetails?.node_type === DISPLAY_TYPE.branch
      ? true
      : playlistDetails?.node_type === DISPLAY_TYPE.playlist_series
        ? true
        : playlistDetails?.node_type === DISPLAY_TYPE.playlist_list && true;

  const isPlayList = (isPlaylist: boolean) => {
    if (isPlaylist) {
      if (pathname?.split("/")?.splice(2).length > 2) {
        return true;
      } else if (pathname?.split("/")?.splice(2).length === 2 && watchId) {
        return true;
      }
    }
    return false;
  };

  const shouldShowVideoPlay =
    !isBranch || isPlayList(playlistDetails?.node_type === DISPLAY_TYPE.playlist_list) || (pathname?.split("/").splice(2)?.length === 2 && watchId);

  const token = cookies[AUTH_COOKIE_TOKEN] || "";

  const getSystemLang = (accept = "") => {
    const systemLang = accept.split(",")[0].split(";")[0].split("-")[0].toLowerCase();
    return systemLang || LANG.english;
  };

  // Helper function to detect if route is a Gujarati default route
  const getRouteNameFromPath = (path: string): string => {
    const segments = path.split("/").filter(Boolean);
    // If first segment is a language code, get the next segment as route name
    if (segments.length > 0 && (segments[0] === "en" || segments[0] === "gu")) {
      return segments[1] || "";
    }
    return segments[0] || "";
  };

  const routeName = getRouteNameFromPath(pathname);
  const isGujaratiRoute = GUJARATI_ROUTE.includes(routeName);

  const user_preferred_lang = returnLanguageIfSupported(cookies[COOKIES_LANGUAGE]);
  const systemLang = getSystemLang(request.headers.get("accept-language") || "");

  // Determine the correct language for this route
  let defaultLang: string;

  if (isGujaratiRoute) {
    // Gujarati routes: use user preference if explicitly saved, otherwise ALWAYS default to Gujarati
    defaultLang = user_preferred_lang || LANG.gujarati;
  } else {
    // Non-Gujarati routes: use user preference if set, otherwise use system language or English
    defaultLang = user_preferred_lang || systemLang || LANG.english;
  }

  // Redirect if:
  // 1. No language prefix in URL, OR
  // 2. Current language doesn't match the default for this route
  const needsRedirect = !lang || lang !== defaultLang;

  if (needsRedirect) {
    // Build the new path with the correct language
    let newPath: string;
    const search = _URL.search; // Preserve query parameters
    if (pathname === "/") {
      newPath = `/${defaultLang}${search}`;
    } else {
      // Remove any existing language prefix if present (only if it's 'en' or 'gu' followed by /)
      const pathWithoutLang = pathname.replace(/^\/(?:en|gu)(?=\/)/, "");
      newPath = `/${defaultLang}${pathWithoutLang}${search}`;
    }

    throw redirect(newPath);
  }

  // Use defaultLang if lang is not set
  const locale = lang ?? defaultLang ?? (await i18next.getLocale(request)) ?? LANG.english;

  try {
    // Parallelize API calls for better performance
    const [categories, footerData] = await Promise.all([
      api.get(`${API_PATH.MENU}`, {
        params: {
          lang: locale,
        },
      }),
      api.get(`${API_PATH.FOOTER}`, {
        params: {
          lang: locale,
        },
      }),
    ]);

    if (categories.status === 200 || footerData.status === 200) {
      return Response.json({
        categories: categories.status === 200 ? categories.data?.data?.menu : [],
        superHeader: categories.status === 200 ? categories.data?.data?.superHeader : null,
        footerData: footerData.status === 200 ? footerData.data?.data : [],
        token: token || null,
        locale,
        watchId: watchId || null,
        media,
        shouldShowVideoPlay,
        ENV: {
          PUBLIC_EASEBUZZ_KEY: process.env.PUBLIC_EASEBUZZ_KEY || "",
          GOOGLE_RECAPTCHA_SITE_KEY: process.env.GOOGLE_RECAPTCHA_SITE_KEY || "",
          API_KEY: process.env.API_KEY || "",
          VAPID_KEY: process.env.VAPID_KEY || "",
          AUTH_DOMAIN: process.env.AUTH_DOMAIN || "",
          PROJECT_ID: process.env.PROJECT_ID || "",
          STORAGE_BUCKET: process.env.STORAGE_BUCKET || "",
          MESSAGING_SENDER_ID: process.env.MESSAGING_SENDER_ID || "",
          APP_ID: process.env.APP_ID || "",
          MEASUREMENT_ID: process.env.MEASUREMENT_ID || "",
        },
      });
    }
  } catch (error) {
    // Handle network or unexpected errors
    throw new Response("Network error while fetching data", {
      status: 500,
      statusText: "Internal Server Error",
    });
  }
}

export const headers: HeadersFunction = ({ loaderHeaders }) => loaderHeaders;

export function Layout({ children }: { children: React.ReactNode }) {
  const { lang } = useParams();
  const error = useRouteError();
  const data = useLoaderData<any>();
  const { i18n } = useTranslation("common");
  useChangeLanguage(data?.locale);

  const { navigate } = useLocale();
  const location = useLocation();
  const env = getEnv();
  const navigationStatus = useNavigation();

  const matches = useMatches();
  const { showTopButton, isSticky } = useDisplayStickyButton();
  const currentRouteId = matches[matches.length - 1].id;
  const currentRouteName = currentRouteId?.replace("routes/", "");

  // useFirebaseNotifications();
  // Initialize activity tracking
  useActivityTracking();

  const isShowMenu = data?.watchId ? true : false;
  const fullWidthRoutesForPlaylist = (hiddenNavbar.includes(currentRouteName) && data?.shouldShowVideoPlay) || isShowMenu;
  const skipNavBarForTwoRoute = (hiddenNavbar.includes(currentRouteName) && data?.shouldShowVideoPlay) || isShowMenu;
  const isSupperHeader = data?.superHeader?.length > 0;
  const HideNavbarForYoutubeVideoPlayer = hiddenNavbar.includes(currentRouteName) && skipNavBarForTwoRoute;

  useEffect(() => {
    // Initialize IndexedDB
    (async () => {
      await IndexedDBService.initDB();
    })();

    // firebase messaging onMessage listener for foreground notifications
    if (typeof window === "undefined" || !("Notification" in window)) return;
    const unsubscribe = onMessage(messaging, (payload: any) => {
      console.log("Foreground message:", payload);

      if (Notification.permission === "granted") {
        const notification = new Notification(payload.data.title, {
          body: payload.data.body,
          icon: payload.data.icon || "/firebase-logo.png",
          data: {
            url: payload.data.route,
          },
        });

        notification.onclick = () => {
          window.location.href = payload.data.route;
        };
      }
    });

    // Listener for messages from the service worker (e.g., for navigation)
    if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "NAVIGATE") {
        window.location.href = event.data.url;
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    // Track page view when location changes
    trackPageView(location.pathname, document.title);
  }, [location]);

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <html>
        <head>
          <title>Page Not Found</title>
          <Meta />
          <Links />
        </head>
        <body>
          <div>
            <NotFoundPage />
          </div>
          <ScrollRestoration />
          <Scripts />
        </body>
      </html>
    );
  }

  if (isRouteErrorResponse(error) && error.status === 500) {
    return (
      <html>
        <head>
          <title>Swaminarayan Bhagwan</title>
          <Meta />
          <Links />
        </head>
        <body>
          <div>
            <InternalServerError />
          </div>
          <ScrollRestoration />
          <Scripts />
        </body>
      </html>
    );
  }

  return (
    <html lang={i18n.language} dir={i18n.dir()} suppressHydrationWarning>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        {/* <link rel="alternate icon" href="/favicon.ico" /> */}
        {/* <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script> */}
        <script src={`https://www.google.com/recaptcha/api.js?render=${env?.GOOGLE_RECAPTCHA_SITE_KEY}`}></script>
        {/* <script src={`https://www.google.com/recaptcha/enterprise.js?render=${env?.GOOGLE_RECAPTCHA_SITE_KEY}`} async defer></script> */}
        {/* <script src="https://www.google.com/recaptcha/enterprise.js" async defer></script> */}
        {/* <script src="https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js"></script> */}

        <Meta />
        <Links i18nIsDynamicList={true} />
      </head>
      <body className="relative" suppressHydrationWarning>
        <StoreProvider>
          <Sheet>
            <SheetContent side={"left"} className="w-screen h-fit bg-white overflow-hidden px-0 pr-5" closeIcon={true} closeBtnCss="-mt-2">
              <SheetHeader className="border-b border-textHeadingColor xs:w-dvw sml:w-[425px] md:w-[385px] -mt-4">
                <div className="flex justify-start px-3 items-center mb-3" onClick={() => navigate(`/`)}>
                  {/* <img src="/icons/logo.svg" alt="swaminarayan bhagawan" className="w-full h-full" /> */}
                  <HeaderImage isMobile={true} />
                </div>
              </SheetHeader>
              <SearchBar isSticky={showTopButton} isSupperHeader={isSupperHeader} className="!ml-5 !w-[calc(100vw-50px)] md:!hidden" isMenu={true} />
              <SheetClose ref={(ref) => (window.closeSheet = () => ref?.click())} className="hidden" />
              <MobileMenu categories={data?.categories || []} onClose={() => window.closeSheet?.()} />
            </SheetContent>

            {data?.superHeader && data.superHeader.length !== 0 && !skipEverything.includes(currentRouteName) && (
              <div className={cn("w-full h-auto flex justify-center items-center")}>
                <SuperHeader superHeader={data?.superHeader[0]} />
              </div>
            )}

            {/* Header */}
            <div
              className={cn(
                `w-full flex flex-col items-center mx:auto bg-customGradient`,
                skipTitlePreview.includes(currentRouteName) || fullWidthRoutesForPlaylist ? "" : "h-full",
                skipNavHeader.includes(currentRouteName) ? "hidden" : "lg:flex",
              )}
            >
              <div
                className={cn(
                  "w-full justify-center",
                  hideHeaderRoutes.includes(currentRouteName) || fullWidthRoutesForPlaylist ? "md:hidden flex" : "flex",
                )}
              >
                <div className="w-full lg:w-[85%] 2xl:w-[80%] md:h-20 z-40">
                  <WebHeader isLogin={!!(data?.token && data?.contentToken)} isSticky={isSticky} isSupperHeader={isSupperHeader} />
                </div>
              </div>

              {/* //desktop menu */}
              {!skipNavHeader.includes(currentRouteName) && (
                <div className={cn("hidden", fullWidthRoutesForPlaylist ? "hidden" : "lg:block my-1 z-20")}>
                  <DesktopMenu categories={data?.categories || []} isSupperHeader={isSupperHeader} />
                </div>
              )}
            </div>

            {!skipNavHeader.includes(currentRouteName) && (
              <div className="sticky top-0 z-40 bg-white">
                <SearchBarAndMenuMobile isSticky={isSticky} isSupperHeader={isSupperHeader} />
              </div>
            )}

            {!skipTitlePreview.includes(currentRouteName) && (
              <div
                className={cn(
                  "block mx-auto",
                  "body-container flex justify-center items-center w-full h-auto py-2",
                  currentRouteName === "$lang.kirtan-lyrics" ? "max-lg:hidden" : "",
                  fullWidthRoutesForPlaylist ? "hidden" : "",
                )}
              >
                <TitlePreview showFilterMenu={displayPlaylistFilter.includes(currentRouteName) && (!data.watchId || !data.media)} />
              </div>
            )}

            {hiddenNavbar.includes(currentRouteName) && skipNavBarForTwoRoute && (
              <div className={cn("body-container z-50 mx-auto py-1.5 hidden lg:flex")}>
                <DesktopMenu
                  categories={data?.categories || []}
                  isSticky={true}
                  isSupperHeader={isSupperHeader}
                  HideNavbarForYoutubeVideoPlayer={HideNavbarForYoutubeVideoPlayer}
                />
              </div>
            )}

            <div className="w-full flex flex-col mx:auto bg-primary h-auto relative">
              {showTopButton && (
                <AnimatePresence mode="sync">
                  <motion.div
                    key="sticky-header"
                    variants={stickyWebHeaderVariants}
                    className={cn(
                      "w-full hidden lg:flex sticky top-0 z-50  justify-center items-center shadow-black/10 shadow-sm bg-primary max-md:hidden",
                    )}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                  >
                    <motion.div className="flex items-center body-container w-full h-[70px] px-4 ">
                      <DesktopMenu categories={data?.categories || []} isSticky={showTopButton} />
                    </motion.div>
                  </motion.div>
                </AnimatePresence>
              )}
              <div className="relative w-full mx-auto flex justify-center">
                <div
                  className={cn(
                    "h-auto",
                    currentRouteName === "$lang.kirtan-lyrics" || hiddenNavbar.includes(currentRouteName) || skipEverything.includes(currentRouteName)
                      ? "mt-0"
                      : "mt-5",
                    fullwidthRoutes.includes(currentRouteName) || fullWidthRoutesForPlaylist ? "w-dvw overflow-x-hidden" : "body-container",
                  )}
                >
                  {children}
                </div>
                {/* )} */}
                <div
                  className="absolute inset-0 w-full h-auto z-[-1] max-md:hidden flex-shrink-0 opacity-30"
                  style={{
                    backgroundColor: "#ffffff",
                    backgroundImage: "url(https://www.transparenttextures.com/patterns/paper-fibers.png)",
                    backgroundRepeat: "repeat",
                    backgroundSize: "auto",
                  }}
                ></div>
                <>
                  <GlobalAudioPlayer />
                  <div className="z-50">
                    <GlobalVideoPlayer />
                  </div>
                </>
              </div>
              <div
                className={cn(
                  "w-full bg-footerBackground flex justify-center items-center h-auto",
                  skipFooter.includes(currentRouteName) ? "hidden" : "",
                  DON_SHOW_FOOTER_IN_MOBILE.includes(currentRouteName) ? "max-md:hidden" : "",
                )}
              >
                <Footer footerData={data?.footerData} />
              </div>
            </div>
            {<ScrollToTopButton showTopButton={showTopButton} showFeedbackButton={!skipFeedBackButton.includes(currentRouteName)} />}

            <script
              dangerouslySetInnerHTML={{
                __html: `window.ENV = ${JSON.stringify(data?.ENV)}`,
              }}
            />

            <ScrollRestoration />
            <Scripts />
            <Toaster />
          </Sheet>
        </StoreProvider>
      </body>
    </html>
  );
}

export default function App() {
  return (
    <Provider store={myStore}>
      <Outlet />
    </Provider>
  );
}

export function ErrorBoundary() {
  const error = useRouteError();
  let displayMessage = "Something went wrong";

  console.error("🚨 ErrorBoundary triggered:", {
    isRouteErrorResponse: isRouteErrorResponse(error),
    error: error instanceof Error ? error.message : error,
    status: isRouteErrorResponse(error) ? error.status : "unknown",
  });

  if (isRouteErrorResponse(error)) {
    if (error.data) {
      if (typeof error.data === "string") {
        displayMessage = error.data;
      } else if (error.data instanceof Error) {
        displayMessage = error.data.message;
      } else {
        // Safely convert object to string
        try {
          displayMessage = String(error.data);
        } catch {
          displayMessage = `Error (Status: ${error.status}) - Check console for details`;
        }
      }
    } else {
      displayMessage = `Server Error (${error.status}) - ${error.statusText}`;
    }
  } else if (error instanceof Error) {
    displayMessage = error.message;
  }

  return (
    <div className="w-full h-screen flex justify-center items-center">
      <NodataFound text={displayMessage} />
    </div>
  );
}
